
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Shivaji Mahotsav</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm shivaji-mahotsav section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Shivaji  <span> Mahotsav</span></h2>
            <p>The life of one of the greatest warrior and ruler of his time, MaharajaChhatrapati Shivaji Rao is an
                epitome of learning. The quotes he said had an impact back then, and are read and imbibed to date.</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-6">
                <div class=" text-justify">
                    <div class="widget_title inner-title">
                        <h4>SHIVAJI MAHOTSAV</h4>
                    </div>
                    <div class="fide-chess-text">
                        <p>"Never bend your head, always hold it high"- Chhatrapati Shivaji</p>
                    </div>
                    <p>
                        The life of one of the greatest warrior and ruler of his time, MaharajaChhatrapati Shivaji Rao
                        is an epitome of learning. The quotes he said had an impact back then, and are read and imbibed
                        to date. His courageous acts have been mentioned in the history books, and they have left an
                        imprint on the students, the historians and the learners alike.
                    </p>

                    <p>
                        Thus, we at the Raisoni Group of Institutions, experience a feeling of proud mingled with
                        happiness to celebrate the Shivaji Mahotsav with immense fervor, zeal and celebrations every
                        year at our college campus.
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/shivaji.webp" alt="GHRSCF">
                </div>
            </div>

        </div>
        <div class="widget_title inner-title">
            <h4>What is Shivaji Mahotsav?
            </h4>
        </div>
        <ul class="list-style list-style1">
            <li>In order to pay tribute to valor, ethics, and principles of Chhatrapati Shivaji, Shivaji Mahotsav is
                celebrated in the college campus.</li>
            <li>It marks a gala festival. </li>
        </ul>
        <div class="widget_title inner-title">
            <h4>What does it involve?
            </h4>
        </div>
        <ul class="list-style list-style1">
            <li>The festivity is organized by the Student council known as the National Student Service Committee.</li>
            <li>The most beautiful traditional dance programs make it to the fest.</li>
            <li>The plays, the dramas and the skits signifying the role of the Great Maratha warrior- Chhatrapati
                Shivaji are performed here.</li>
            <li>The martial art performances indicating the valor of the ruler are portrayed in the function.</li>
            <li>The inaugural function of Antaragni and Technorion also takes place.</li>
            <li>There is also a Celebrity attendance in the program.</li>
            <li>The students wear traditional attire. The Girls wear Navarris and the Boys wear traditional Kurta!</li>
            <li>All the attendees make sure to adorn their heads with saffron pethas.</li>
        </ul>
        <div class="widget_title inner-title">
            <h4>What is in it for the students?
            </h4>
        </div>
        <ul class="list-style list-style1">
            <li>Execution and organization by the students belonging to the NSS Committee.</li>
            <li>Participation by the students.</li>
            <li>Understanding the stories woven around the valor and strength of the greatest ruler of his time through
                skits, dance, and drama.</li>
        </ul>

        <div class="fide-chess-text">
            <p>It is matchless! The ambience, the high spirit, and the fervor!!!</p>
        </div>

        <h2 class="text-center mt-5">Jai Shivaji! Jai Shivaji! </h2>

        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>PHOTOS</h4>
                </div>
            </div>
            <div class="col-md-4 text-end">
                <a href="photogallery#ShivajiJayanti" target="_blank" class="cmn-button"><span>
                        View More</span>
                </a>
            </div>
        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_8.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_8.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s_8.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>

            </ul>
        </div>


    </div>
</section>
